export default __webpack_public_path__ + "static/sophia-ec8ec600b5d0008a85ecf0c8faf1cc73.png";